
export class ReferAFriendRequest {
  referToUserId:	string;
  referralType:	ReferralType;
  firstName:	string;
  lastName:	string;
  userContact:	string;
  email:	string;
  phone:	string;
  note:	string;
  // WI 24859 — agent Borrower referral extra fields
  loanPurpose?: string;            // 'Purchase' | 'Refinance'
  loanRequestPurpose?: string;     // Goal of This Loan
  subjectPropertyCity?: string;
  subjectPropertyState?: string;
  subjectPropertyZip?: string;
  // LLS-280 — agent Borrower referral language preference. Values match the Api's Language enum
  // names ('English' | 'Spanish' | 'Chinese' | 'Korean' | 'Vietnamese' | 'Tagalog' | 'Other'),
  // which it serializes by name.
  languagePreference?: string;
  languagePreferenceOtherDescription?: string;   // only sent when languagePreference is 'Other'
  referredByName:	string;
  referredByEmail:	string;
  referredByPhone:	string;
}

export enum ReferralType {
  Borrower = "Borrower",
  Agent = "Agent"
}
